import * as Yup from "yup";
import { createOption } from "../../../../../../../constants/options";
import { parseIntoDateObject } from "../../../../../../../utils/helpers/dateHelper";
import { addDays, addBusinessDays } from 'date-fns'

export const addDaysAfterToday = (days) => addDays(new Date(), days);

export const addBusinessDaysAfterToday = (days) => addBusinessDays(new Date(), days);

export const getValidDates = (startDate, endDate) => {
  let dates = [];
  while (startDate <= endDate) {
    dates = [...dates, new Date(startDate)];
    startDate = addDays(startDate, 1);
  }
  return dates;
};

export const convertDateStringToDateObject = (dateString) => {
  const clientSideValueAsDate = new Date(dateString);
  return parseIntoDateObject(clientSideValueAsDate);
};

export const createWorkDaySelectOptions = (dates) => {
  return dates
    .filter((date) => {
      const dayOfWeek = date.getUTCDay();
      return dayOfWeek !== 0 && dayOfWeek !== 6;
    })
    .map((date) => {
      return createOption(
        date.toDateString(),
        new Date(date.getFullYear(), date.getMonth(), date.getDate()).toString()
      );
    });
};

export const createRequiredDateDropdownShape  = () => ({
  month: Yup.string()
    .trim()
    .required("Please select a date"),
});